import { render, staticRenderFns } from "./InfoDateMessageRow.vue?vue&type=template&id=75453084&scoped=true&"
import script from "./InfoDateMessageRow.vue?vue&type=script&lang=js&"
export * from "./InfoDateMessageRow.vue?vue&type=script&lang=js&"
import style0 from "./InfoDateMessageRow.vue?vue&type=style&index=0&id=75453084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75453084",
  null
  
)

export default component.exports